<template>
<div>
<form v-on:submit.prevent="editSettings">

<nav class="back">
  <router-link :to="{ name: 'Dashboard' }">&lt; Return to dashboard</router-link>
</nav>

<section>
  <h2>App Details</h2>

  <div class="field">
    <label>App Name</label>
    <div class="control">
      <input v-model="settings.app.name" type="text" placeholder="Form Name">
      <p class="help">This is visible to both clients and end users.</p>
    </div>
  </div>

  <div class="field">
    <label>Login URL</label>
    <div class="control">
      <input v-model="settings.app.login" type="text" placeholder="Form Name">
      <p class="help">Dashboard URL. Sent to clients if clientLogin is enabled.</p>
    </div>
  </div>

  <div class="field">
    <label>Optout URL</label>
    <div class="control">
      <input v-model="settings.app.optout" type="text" placeholder="Form Name">
      <p class="help">URL to a form to handle email optout requests.</p>
    </div>
  </div>

</section>

<section>
  <h2>Feature Toggles</h2>
  <div class="field">

  <div>
    <toggle-button v-model="settings.processEntries" :sync="true" />
    <label v-if="settings.processEntries">Enable Entry Submission</label>
    <label v-else>Disable Entry Submission</label>
  </div>

    <p class="help">Globally enable or disable submission of new entries</p>
  </div>

  <div v-if="!settings.processEntries" class="notification is-warning">
    <p><strong>ALL FORMS ARE DISABLED. NO ENTRY FOR ANY FORM WILL BE PROCESSED.</strong></p>
    <p>
      A disabled form will not process <strong>(save or send)</strong> any submissions.
      End users will see a notice asking them to submit again at a later date.
    </p>
  </div>

  <div class="field">

    <div>
      <toggle-button v-model="settings.userLogin" :sync="true" />
      <label v-if="settings.userLogin">Enable Client Login</label>
      <label v-else>Disable Client Login</label>
    </div>
    <p class="help">Allow or disallow clients to login and view their forms</p>
  </div>

</section>

<section>
  <h2>Anti Spam</h2>

  <div class="field">
    <p class="help">See toggle in form edit to perform additional spam checks</p>
  </div>

  <div class="field">
    <label>
      Words Blacklist
      <a class="button" @click="blacklistAdd('word')">Add New</a>
    </label>
    <div class="control">
    <div v-for="(item, index) in this.settings.blacklist.word" :key="index">
      <input type="text" v-model="settings.blacklist.word[index]" class="hasAddon">
      <a class="addon" @click="blacklistRemove('word', index)">Remove</a>
    </div>
    </div>
  </div>

  <div class="field">
    <label>
      Email Blacklist
      <a class="button" @click="blacklistAdd('email')">Add New</a>
    </label>
    <div class="control">
    <div v-for="(item, index) in this.settings.blacklist.email" :key="index">
      <input type="text" v-model="settings.blacklist.email[index]" class="hasAddon">
      <a class="addon" @click="blacklistRemove('email', index)">Remove</a>
    </div>
    </div>
  </div>

  <div class="field">
    <label>
      IP Blacklist
      <a class="button" @click="blacklistAdd('ip')">Add New</a>
    </label>
    <div class="control">
    <div v-for="(item, index) in this.settings.blacklist.ip" :key="index">
      <input type="text" v-model="settings.blacklist.ip[index]" class="hasAddon">
      <a class="addon" @click="blacklistRemove('ip', index)">Remove</a>
    </div>
    </div>
  </div>

</section>

  <div v-if="error" class="message is-danger">
    <div class="message-header">Error saving settings:</div>
    <div class="message-body"><p>{{error}}</p></div>
  </div>

  <button class="edit button is-large is-info is-fullwidth">Save Settings</button>
</form>

</div>
</template>

<script>
/* eslint-disable import/no-cycle */
import Api from '@/services/Api';

export default {
  props: [],
  data() {
    return {
      error: '',
      settings: { app: {}, blacklist: {} },
    };
  },
  async created() {
    Api().get('settings').then(async (res) => {
      this.settings = res.data;
    });
  },
  watch: {
  },
  methods: {
    editSettings() {
      const appSettings = {

        processEntries: this.settings.processEntries,
        userLogin: this.settings.userLogin,
        app: {
          name: this.settings.app.name,
          login: this.settings.app.login,
          optout: this.settings.app.optout,
        },
        blacklist: {
          word: this.settings.blacklist.word,
          email: this.settings.blacklist.email,
          ip: this.settings.blacklist.ip,
        },
      };

      Api().post('settings', appSettings).then((res) => {
        this.settings = res.data;
        this.$router.push('/');
      }).catch((err) => {
        this.error = err.response.data.error;
      });
    },
    blacklistRemove(list, index) {
      this.settings.blacklist[list].splice(index, 1);
    },
    blacklistAdd(list) {
      this.settings.blacklist[list].push('');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: var(--black);
    color: var(--white);
    padding: 0.5em;
    z-index: 1;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),
      0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
  }

  .back a {
    color: var(--white);
    text-decoration: none;
    padding: 15px 30px;
  }

  form { overflow-y: scroll; width: 100vw; height: 100vh; padding: 2em; }

  section {
    padding-bottom: 2em;
  }

  section h2 {
    font-size: 120%;
    font-weight: 300;
    text-transform: uppercase;
    border-bottom: 1px solid black;
    margin-bottom: 1em;
  }

  form .field { margin-bottom: 1.2em; }

  form .create { margin-bottom: 2em; }

  form .field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5em;
    padding: 1em;
    border-radius: 5px;
    background: white;
  }

  form .control  {
    width: 70%;
  }

  form label {
    font-weight: bold;
    padding-left: 0.5em;
  }

  form input {
    border: none;
    padding: 0.75em;
    width: 100%;
    background: lightgray;
  }

  form .help {
    font-size: 80%;
    margin: 0;
    padding: 5px 0;
  }

  form input.hasAddon {
    width: 80%;
    margin-bottom: 5px;
  }

  form .control .addon {
    width: 20%;
    background: var(--red);
    padding: 0.70em;
    cursor: pointer;
  }

  form .field label .button {
    background: var(--green);
    font-weight: normal;
    margin: 15px 0;
    display: block;
    padding: 0.5em;
    cursor: pointer;
  }

  .notification.is-warning {
    background: var(--yellow);
    padding: 1em;
    border-radius: 5px;
    margin-bottom: 2em
  }

  .notification p {
    text-align: center;
  }

  form button.edit {
    width: 100%;
    padding: 1em;
  }
</style>
